module.exports = __webpack_public_path__ + "img/1.1.6eff15ee.png";